import en from './en';
import fr from './fr';

const UserGuide = {
  en,
  fr,
};

export default UserGuide;
